import {
  Button,
  Icon,
  Typography,
  useWindowSize,
} from '@data-products-and-ai/react-components';
import { useNavigate } from 'react-router';
import { OUTAGES_ROUTE } from '@/pages/Outages/routes';
import { TABLET_WIDTH } from '@/constants';

import '@/pages/Home/styles.scss';

export const HomePage = () => {
  const navigate = useNavigate();
  const { width } = useWindowSize();

  const handleClick = () => {
    navigate(OUTAGES_ROUTE);
  };

  const handleGoToVideo = () => {
    window.open(
      'https://siemensenergyag.sharepoint.com/:v:/r/teams/M_PESVCatalysts/Shared%20Documents/General/02_Demand%20Documentation/Ongoing%20Demands/960_EQS_safety_incidents/Demos/20251219%20SAFEMillwrightApp%20release%20v1.mp4?csf=1&web=1&e=d7FnhN',
      '_blank',
      'noopener,noreferrer',
    );
  };

  return (
    <div className="home">
      <div className="home-title">
        <Typography
          tag={width <= TABLET_WIDTH ? 'h3' : 'h2'}
          color="var(--color-black)"
        >
          Welcome to <strong>SAFE</strong>
        </Typography>
      </div>
      <div className="home-left">
        <Typography tag="textsmall">
          <strong>SAFE</strong> is a <strong>S</strong>afety <strong>A</strong>
          nalysis & <strong>F</strong>ield <strong>E</strong>vent management
          platform for millwrights, leveraging data-driven safety intelligence
          to proactively reduce workforce risk during outages.
        </Typography>
        <Typography tag="textsmall">
          Using a machine learning model trained on historical incident and
          workforce data, the app calculates accident risk indicators at both
          outage level and millwright level. These insights are presented
          through an intuitive interface that combines risk scores with key
          workforce and outage KPIs, giving you a clear and actionable safety
          overview.
        </Typography>
        <Typography tag="textsmall">
          If you oversee multiple outages or the entire workforce, you can start
          at the outage level to quickly identify which outages present higher
          risk and may require closer attention. From there, you can drill down
          to understand contributing factors and focus your investigation where
          it matters most.
        </Typography>
        <Typography tag="textsmall">
          If you are responsible for a specific outage, you can navigate
          directly to it, compare its risk profile with others, and explore
          detailed information about the assigned workforce.
        </Typography>
        <Typography tag="textsmall">
          Within an outage, <strong>SAFE</strong> allows you to drill down to
          the individual millwright level, highlighting potential elevated risk
          and supporting indicators such as worked hours, double hours, training
          status, and certifications. These insights help you identify where
          preventive actions may be needed—such as workload adjustments,
          training refreshers, or certification updates.
        </Typography>
        <Typography tag="textsmall">
          <strong>SAFE</strong> is not a judgment tool, but a decision-support
          system—helping you ask the right questions, take timely action, and
          ultimately improve safety outcomes for individuals, outages, and the
          workforce as a whole.
        </Typography>
        <Typography tag="textsmall_strong">
          IMPORTANT: Risk data is updated daily at 6:00 AM UTC (1:00 AM EST) and
          is based on historical information from the previous six months.
        </Typography>
        <div className="home-left__actions">
          <Button
            allCaps={false}
            type="link"
            icon={
              <Icon
                icon="IconLinkExternal"
                iconSize={0.75}
                color="var(--color-primary)"
              />
            }
            onClick={handleGoToVideo}
            iconPosition="right"
          >
            <Typography tag="textsmall" color="var(--color-primary)">
              SAFE: How To Video
            </Typography>
          </Button>
          <Button
            allCaps={false}
            type="primaryNoShadow"
            size="small"
            icon={
              <Icon
                icon="IconArrowRight"
                color="var(--color-white)"
                iconSize={0.75}
              />
            }
            iconPosition="right"
            onClick={handleClick}
          >
            <Typography tag="textsmall">Check outages risk score</Typography>
          </Button>
        </div>
      </div>
      <div className="home-right">
        <img
          className="home-right__image"
          src="/images/app.png"
          alt="Millwrights"
        />
      </div>
    </div>
  );
};
